import { _axios } from "@api/axiosinstance";
import IUpdatesAPI, { DeviceUpdateStatus, UpdateStatus } from "./UpdatesAPI";

class LiveUpdatesAPI implements IUpdatesAPI {
    getUpdateCount(queryParams?: string): Promise<number> {
        let queryParamsString: string = '';
        const queryParamsLength:any = queryParams?.length;

        if (queryParamsLength && queryParamsLength > 0) {
            queryParamsString = '?'+queryParams;
        }

        return new Promise<number>((resolve, reject) => {
            _axios.get(`updatescount${queryParamsString}`).then(response => {
                if (response.status !== 200) reject(response.statusText);
                resolve(response.data);
            }).catch(error => {
                reject(error);
            });
        });
    }
    getDetailedUpdateList(deviceId: string, type: string): Promise<DeviceUpdateStatus[]> {
        return new Promise<DeviceUpdateStatus[]>((resolve, reject) => {
            _axios.get(`updates/${type}/${deviceId}`).then(response => {
                if (response.status !== 200) reject(response.statusText);
                resolve(response.data);
            }).catch(error => {
                reject(error);
            });
        });
    }
    getUpdateStatusList(): Promise<UpdateStatus[]> {
        return new Promise<UpdateStatus[]>((resolve, reject) => {
            _axios.get('statuses').then(response => {
                if (response.status !== 200) reject(response.statusText);
                resolve(response.data);
            }).catch(error => {
                reject(error);
            });
        });
    }
    getDevicesUpdateInfo(queryParams?: string, pageNum?: number, countPerPage?: number): Promise<DeviceUpdateStatus[]> {
        const queryParamsLength:any = queryParams?.length;
        let queryParamsString: string = '';

        if (queryParamsLength > 0 && queryParamsLength) {
            queryParamsString = queryParams + '&';
        }

        return new Promise<DeviceUpdateStatus[]>((resolve, reject) => {
            _axios.get(`updates?${queryParamsString}pageNum=${pageNum}&countPerPage=${countPerPage}`).then(response => {
                if (response.status !== 200) reject(response.statusText);
                resolve(response.data);
            }).catch(error => {
                reject(error);
            });
        });
    }
}

export default LiveUpdatesAPI;